import { createContext } from "react";

/** Avoid a legacy footer inside content that already has the redesigned footer. */
export const RetainedLayoutContext = createContext(false);